import {
  Table as CSDTable,
  Box,
  Header,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { Link } from "react-router-dom";
import { LABELS } from "./constants";
import { useEffect, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "../../configs/constants";
import { getHeaderCounterText, getPagedItems } from "../../utils/common";
import { useGetRelatedExaminationContentQuery } from "../../features/api";
import { COMMON_LABELS } from "../default-constants";
import Pagination from "../UI/Pagination";
import Preference from "../UI/Preference";

interface ITable {
  examinationApplicationNo: string;
}

const columnDefinitions = [
  {
    id: "examinationType",
    header: LABELS.EXAMINATION_TYPE,
    cell: (e: any) => e.relatedExaminationType,
  },
  {
    id: "examinationApplicationNo",
    header: LABELS.EXAMINATION_APPLICATION_NO,
    cell: (e: any) => (
      // 関連の審査内容照会画面遷移
      <Link to={"/examination-inquiry/" + e.relatedExaminationApplicationNo}>
        {e.relatedExaminationApplicationNo}
      </Link>
    ),
  },
];

/**
 * 審査依頼先一覧
 */
const RelatedExaminationList = (props: ITable) => {
  const { examinationApplicationNo } = props;
  //一覧データの取得
  const { data, isFetching, refetch } = useGetRelatedExaminationContentQuery({
    examinationApplicationNo: examinationApplicationNo!,
  });

  /**ページャ関連 */
  const options = columnDefinitions.map((column) => ({
    id: column.id,
    label: column.header,
  }));
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [preferences, setPreferences] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    visibleContent: options.map((o) => o.id),
  });

  const [pagedItems, setPagedItems] = useState<Object[]>([]);
  const [allItems, setAllItems] = useState<Object[]>([]);
  useEffect(() => {
    if (data !== undefined) {
      setPagedItems(getPagedItems(data, 1, preferences.pageSize));
      setAllItems(data);
      setCurrentPageIndex(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  /** 設定変更関数 */
  const handleOnConfirm = (detail: any) => {
    const newPageSize = detail.pageSize;
    setPreferences({
      pageSize: newPageSize,
      visibleContent: detail.visibleContent,
    });
    if (data !== undefined) {
      setPagedItems(data.slice(0, newPageSize));
      setCurrentPageIndex(1);
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      loading={isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      items={pagedItems}
      resizableColumns
      stickyHeader
      header={
        <SpaceBetween size={"xs"}>
          <Header>
            {LABELS.RELATED_TITLE}
            {getHeaderCounterText(allItems.length, pagedItems.length)}
          </Header>
        </SpaceBetween>
      }
      pagination={
        <Pagination
          currentPageIndex={currentPageIndex}
          filteredItems={allItems}
          setCurrentPageIndex={setCurrentPageIndex}
          pageSize={preferences.pageSize}
          setPagedItems={setPagedItems}
        />
      }
      preferences={
        <Preference
          preferences={preferences}
          options={options}
          handleOnConfirm={handleOnConfirm}
        />
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default RelatedExaminationList;
